import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Tabs from '../SegmentBar/TabBar';
import './UserFeedback.css';
import TableComponent from "../TableComponent/TableComponent.jsx";
import { fetchFeedbackResponsesProd } from "../services/FirebaseService.js";
import InterfaceSpec from "../InterfaceSpecCard/InterfaceSpec.jsx";

function UserFeedbacks() {
    const navigate = useNavigate();
    const [userFeedbackData, setUserFeedbackData] = useState([]); // State to hold the table data
    const location = useLocation();
    const [activeIndex, setActiveIndex] = useState(0); // Default to "LDC Feedbacks"
    const [activeSpecIndex, setActiveSpecIndex] = useState(0);
    const [interfaceSpecCount, setInterfaceSpecCount] = useState(0);
    const feedbackDictionary = React.useRef({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                feedbackDictionary.current = await fetchFeedbackResponsesProd("User Feedback Response/PROD"); // Fetch data
                console.log("Fetched User Feedback Data:", feedbackDictionary);
                updateUserFeedbackData(); // Update the state with the fetched data
                // var sorted_data = feedbackData.sort((a, b) => {
                //     return new Date(a.timestamp).getTime() -
                //         new Date(b.timestamp).getTime()
                // }).reverse();
                // setUserFeedbackData(sorted_data); // Update the state with the fetched data
            } catch (err) {
                console.error("Error fetching user feedback data:", err);
            }
        };
        fetchData();
        // Update the active index based on the current route
        if (location.pathname === "/user-feedbacks") {
            setActiveIndex(0);
        } else if (location.pathname === "/feature-requests") {
            setActiveIndex(1);
        } else if (location.pathname === "/reported-issues") {
            setActiveIndex(2);
        }
    }, [location.pathname]);

    useEffect(() => {
        updateUserFeedbackData();
    }, [activeSpecIndex]);

    const handleTabSelect = (index) => {
        console.log(`Selected Tab: ${index}`);
        const paths = ["/user-feedbacks", "/feature-requests", "/reported-issues"];
        setActiveIndex(index);
        if (index !== 0) {
            navigate(paths[index]);
        }
    };

    const columns = React.useMemo(
        () => [
            { Header: "Timestamp", accessor: "timestamp" },
            { Header: "Q1: How would you rate your overall experience of the installation and configuration?", accessor: "installConfigRating" },
            { Header: "Q1.1 : Can you tell us why you had a negative experience with the installation so we can improve it?", accessor: "negativeInstallReason" },
            { Header: "Q2 : About how long did the install take end to end from hardware installation and pairing/configuration using the mobile app?", accessor: "timeForInstall" },
            { Header: "Q3 : How would you rate your overall experience using the MyInsights Mobile App for this installation? ", accessor: "appRating" },
            { Header: "Q3.1 : Can you tell us why you had a negative experience with the installation so we can improve it?", accessor: "negativeAppReason" },
            { Header: "Q4 : What would make this installation process easier? ", accessor: "installSuggestion" },
            { Header: "Q5 : Any other thoughts or feedback? ", accessor: "otherFeedback" },
            { Header: "Hour Meter Config Key ", accessor: "Key" },
            { Header: "Hour Meter Config Lift", accessor: "Lift" },
            { Header: "Hour Meter Config Operator Presence", accessor: "Operator Presence" },
            { Header: "Hour Meter Config Travel", accessor: "Travel" },
            { Header: "DHU Firmware Version", accessor: "fwVersion" },
            { Header: "Device Serial Number", accessor: "deviceSerialNumber" },
            { Header: "Mobile App Version", accessor: "Mobile App Version" },
            { Header: "Mobile Brand", accessor: "Mobile Brand" },
            { Header: "Mobile Model", accessor: "Model" },
            { Header: "OS Version", accessor: "OS Version" },
            { Header: "User Lang Pref", accessor: "User Language Preference" },
            { Header: "Vehicle Interface Spec", accessor: "vehicleInterfaceSpec" },
            { Header: "Vehicle Model", accessor: "vehicleModel" },
            { Header: "Vehicle Serial", accessor: "vehicleSerial" },
            { Header: "User ID", accessor: "userId" },
            { Header: "User Role", accessor: "userRole" },
        ],
        []
    );

    const interfaceSpecs = [
        {
            topLabel: "Vehicle Controller",
            bottomLabel: "(CAN BUS ONLY)",
            centerLabel: String((feedbackDictionary.current.vehicle_controller || []).length)
        },
        {
            topLabel: "Vehicle Controller +",
            bottomLabel: "Wired (Toyota Legacy)",
            centerLabel: String((feedbackDictionary.current.hybrid || []).length)
        },
        {
            topLabel: "Vehicle Controller +",
            bottomLabel: "(Raymond CLASS I & II)",
            centerLabel: String((feedbackDictionary.current.raymond_class_I_II || []).length)
        },
        {
            topLabel: "Vehicle Controller +",
            bottomLabel: "(Raymond CLASS III)",
            centerLabel: String((feedbackDictionary.current.raymond_class_III || []).length)
        },
        {
            topLabel: "Wired",
            bottomLabel: "",
            centerLabel: String((feedbackDictionary.current.wired || []).length)
        }
    ];

    const updateUserFeedbackData = () => {
        switch (activeSpecIndex) {
            case 0:
                setUserFeedbackData(feedbackDictionary.current.vehicle_controller);
                break;
            case 1:
                setUserFeedbackData(feedbackDictionary.current.hybrid);
                break;
            case 2:
                setUserFeedbackData(feedbackDictionary.current.raymond_class_I_II);
                break;
            case 3:
                setUserFeedbackData(feedbackDictionary.current.raymond_class_III);
                break;
            case 4:
                setUserFeedbackData(feedbackDictionary.current.wired);
                break;
            default:
                setUserFeedbackData(feedbackDictionary.current.vehicle_controller);
                break;
        }
    };

    const safeData = Array.isArray(userFeedbackData) ? userFeedbackData : [];

    return (
        <div className="FeatureRequests">
            <div className="tab-container">
                <Tabs
                    tabs={["LDC Feedbacks", "Feature Requests", "Reported Issues"]}
                    activeIndex={activeIndex}
                    onTabSelect={handleTabSelect}
                />
            </div>
            <div className="feature-content">
                <div className="BodyFeatureRequest">
                    User Feedbacks for Local Device Configurations
                </div>
                <div className="interface-spec-list">
                    {interfaceSpecs.map((spec, idx) => (
                        <InterfaceSpec
                            key={idx}
                            topLabel={spec.topLabel}
                            bottomLabel={spec.bottomLabel}
                            centerLabel={spec.centerLabel}
                            active={activeSpecIndex === idx}
                            onClick={() => setActiveSpecIndex(idx)}
                        />
                    ))}
                </div>
            </div>
            <div className="table-scroll-container">
                {safeData.length === 0 ? (
                    <div className="no-feedback-message">
                        No user feedback data available for the selected configuration.
                    </div>
                ) : (
                    <TableComponent columns={columns} data={safeData} />
                )}
            </div>
        </div>
    );
}

export default UserFeedbacks;